import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import './index.scss'
export const Toggle = ({ onClick, displayText, status }: any) => {
    return <div className="toggle-text" onClick={onClick} >
        <div className="icon">
            {status && <FontAwesomeIcon icon={faChevronDown} />}
            {!status && <FontAwesomeIcon icon={faChevronUp} />}
        </div>
        <div>
            {displayText}
        </div>

    </div>
}